import { Temporal, parsePlainDate } from '@shared/lib/date-time';

/** Номер платёжного поручения как у backend `RussianRequisites`: буквы, цифры, «.», «/», «-», до 64 символов. */
export const paymentOrderError = (value: string): string | null =>
  /^[\p{L}0-9./-]{1,64}$/u.test(value.trim()) ? null : 'Укажите номер платёжного поручения.';

/** Дата по выписке или перевода: не в будущем и не раньше `notBefore` (пустая строка — без нижней границы). */
export const bankDateError = (
  value: string,
  today: Temporal.PlainDate | null,
  notBefore: string,
  notBeforeText: string,
): string | null => {
  const date = parsePlainDate(value);
  if (date === null) return 'Укажите дату.';
  if (today !== null && Temporal.PlainDate.compare(date, today) > 0) return 'Дата не может быть в будущем.';
  const earliest = parsePlainDate(notBefore);
  if (earliest !== null && Temporal.PlainDate.compare(date, earliest) < 0) return `Дата не раньше ${notBeforeText}.`;

  return null;
};
